import { useClientAreasSuspense } from "@/api/areas/queries";
import { Area } from "@/api/areas/types";
import { createContext, useContext } from "react";

type ClientAreasDataLoaderProps = {
  children: React.ReactNode;
};

type ClientAreasDataProvider = {
  areas: Area[];
};

const ClientAreasDataProvider = createContext<ClientAreasDataProvider>({
  areas: [],
});

export const useClientAreasDataProvider = () => {
  const context = useContext(ClientAreasDataProvider);
  if (!context) {
    throw new Error(
      "useClientAreasDataProvider must be used within a ClientAreasDataLoader"
    );
  }
  return context;
};

const ClientAreasDataLoader = ({ children }: ClientAreasDataLoaderProps) => {
  const { data: areas } = useClientAreasSuspense();

  return (
    <ClientAreasDataProvider.Provider
      value={{
        areas: areas || [],
      }}
    >
      {children}
    </ClientAreasDataProvider.Provider>
  );
};

export default ClientAreasDataLoader;
